import { Dispatch } from 'react';
import api from 'src/api/api';
import { HEADERS } from 'src/constants/headers';
import { SET_LOADING } from 'src/contexts/types';
import { handleError } from 'src/contexts/utils/handleError';
import { DELETE_STORE_GROUP } from '../constants/actions';
import { TStoreGroupActionTypes } from '../types';

/**
 * Will delete a store group by id
 *
 * @param {Dispatch<TStoreGroupActionTypes>} dispatch
 * @param {string} storeGroupId
 */
export const deleteStoreGroup = async (
    dispatch: Dispatch<TStoreGroupActionTypes>,
    storeGroupId: string
) => {
    dispatch({ type: SET_LOADING });
    try {
        const res = await api.delete(
            `/store-groups/${storeGroupId}`,
            HEADERS()
        );
        dispatch({ type: DELETE_STORE_GROUP, payload: res.data.deletedId });
    } catch (error) {
        dispatch(handleError(error));
    }
};
